import type * as React from 'react';
import { del } from '@Domain/Api';
import templateAssignmentScopePath from '@Application/Documents/TemplateAssignments/templateAssignmentScopePath';
import templateAssignmentCleared, {
	type TemplateAssignmentClearedAction,
} from '@Application/Documents/TemplateAssignments/Actions/templateAssignmentCleared';
import templateAssignmentClearFailed, {
	type TemplateAssignmentClearFailedAction,
} from '@Application/Documents/TemplateAssignments/Actions/templateAssignmentClearFailed';
import type ClearTemplateAssignment from '@Application/Documents/TemplateAssignments/Commands/ClearTemplateAssignment';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../../parameters';

type Actions = TemplateAssignmentClearedAction | TemplateAssignmentClearFailedAction;

export default (command: ClearTemplateAssignment) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			await del<void>(
				`${parameters.api.host}/api/${templateAssignmentScopePath(command.scope)}/${command.documentTypeId}`,
			);

			const action = templateAssignmentCleared(
				{ documentTypeId: command.documentTypeId },
				command.scope,
			);
			dispatch(action);
			return action;
		} catch (error) {
			const action = templateAssignmentClearFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
